import { createFileRoute } from '@tanstack/react-router'

import { RenewalPage } from '../../../../components/pages/renewal/renewal-page.tsx'

export const Route = createFileRoute('/s/r/$token')({
  component: RenewalPage,
})
